import React, { useState, } from "react";
import "./coins-onchain-statuses.scss";
import * as DateUtil from "../../../utils/date";
import * as NumberUtil from "../../../utils/number";

import Table from '../../elements/table/table';
import Modal from "../../common/modal/modal";

const CoinsOnchainStatuses = () => {

  const [showValue,setShowValue] = useState(null);
  const [showModal,setShowModal] = useState(false);

  const sideItems = [];

  const columns = [
    {table: "coinOnchainStatuses",value: "id",hide: true, index:true, },
    {table: "coinOnchainStatuses",value: "coin", index:true,},
    {table: "coinOnchainStatuses",value: "addressGeneration",
      custom: ({v,cv}) => <div className={(v[cv])?"on":"off"}><span>{(v[cv])?"On":"Off"}</span></div>,  },
    {table: "coinOnchainStatuses",value: "deposits",
      custom: ({v,cv}) => <div className={(v[cv])?"on":"off"}><span>{(v[cv])?"On":"Off"}</span></div>,  },
    {table: "coinOnchainStatuses",value: "depositConfirmations",},
    {table: "coinOnchainStatuses",value: "withdrawals",
      custom: ({v,cv}) => <div className={(v[cv])?"on":"off"}><span>{(v[cv])?"On":"Off"}</span></div>,  },
    {table: "coinOnchainStatuses",value: "withdrawalFeeSats", display:"Withdrawal Fee",
      custom: ({v,cv}) => <div>{NumberUtil.satsToVal(v[cv])}</div>,  },
    {table: "coinOnchainStatuses",value: "withdrawalMinimumSats", display:"Withdrawal Minimum",
      custom: ({v,cv}) => <div>{NumberUtil.satsToVal(v[cv])}</div>,  },
    {table: "coinOnchainStatuses",value: "depositFeeSats", display:"Deposit Fee",
      custom: ({v,cv}) => <div>{NumberUtil.satsToVal(v[cv])}</div>,  },
    {table: "coinOnchainStatuses",value: "depositMinimumSats", display:"Deposit Minimum",
      custom: ({v,cv}) => <div>{NumberUtil.satsToVal(v[cv])}</div>,  },
    {table: "coinOnchainStatuses",value: "createdDate", index:true,
      custom: ({v,cv}) => <div>{DateUtil.dateTimeSince(v[cv])}</div>,  
    },
    {table: "coinOnchainStatuses",value: "updatedDate", index:true,
      custom: ({v,cv}) => <div>{DateUtil.dateTimeSince(v[cv])}</div>,  
    },
  ]
  const joinOptions = [
    // {joinType:"LEFT JOIN",leftTable:"outputs",rightTable:"addresses",leftColumn:"address",rightColumn:"address",},
  ]

  return (
    <div className="coin-onchain-statuses-comp">
      <div className="coin-onchain-statuses-comp-header">
        <h3>Coin Onchain Statuses</h3>
      </div>
      <Table 
        database={"Node"}
        displayName="CoinsOnchainStatuses"
        name="CoinsOnchainStatusesTable"
        sideItems={sideItems}
        sideItemActiveClickFunc={(item) => {
          // console.log("item",item);
        }}
        joinOptions={joinOptions}
        rowOnClickFunc={(value) => {
          setShowValue(value);
          setShowModal(true);
        }}
        columns={columns}
        limit={250}
        />

      <Modal className="coin-onchain-statuses-modal" show={showModal} handleClose={() => {setShowModal(false)}}>
        <div className="coin-onchain-statuses-modal-main">
          <pre>
          {JSON.stringify(showValue, null, 2)}
          </pre>
        </div>
      </Modal>

    </div>
  );
};

export default CoinsOnchainStatuses;
